import { Badge } from "@/components/ui/badge";

const MAP = {
  approved: { label: "Aprovada", cls: "bg-green-500/15 text-green-600 dark:text-green-400 border-green-500/30" },
  pending: { label: "Pendente", cls: "bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30" },
  incorrect: { label: "Dados incorretos", cls: "bg-orange-500/15 text-orange-600 dark:text-orange-400 border-orange-500/30" },
  refunded: { label: "Estornado", cls: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30" },
  failed: { label: "Falhou", cls: "bg-destructive/15 text-destructive border-destructive/30" },
  // tickets
  aberto: { label: "Aberto", cls: "bg-blue-500/15 text-blue-600 dark:text-blue-400 border-blue-500/30" },
  em_atendimento: { label: "Em atendimento", cls: "bg-primary/15 text-primary border-primary/30" },
  aguardando_usuario: { label: "Aguardando você", cls: "bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30" },
  aguardando_equipe: { label: "Aguardando equipe", cls: "bg-purple-500/15 text-purple-600 dark:text-purple-400 border-purple-500/30" },
  resolvido: { label: "Resolvido", cls: "bg-green-500/15 text-green-600 dark:text-green-400 border-green-500/30" },
  fechado: { label: "Fechado", cls: "bg-muted text-muted-foreground border-border" },
};

export default function StatusBadge({ status }) {
  const s = MAP[status] || { label: status, cls: "bg-muted text-muted-foreground" };
  return (
    <Badge variant="outline" className={s.cls} data-testid={`status-${status}`}>
      {s.label}
    </Badge>
  );
}
